module.exports = __webpack_public_path__ + "assets/img/5.ecaaa2a2.png";